import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from './constants';

const dashboardService = createApi({
    reducerPath: 'dashboardService',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('admin')
                ? JSON.parse(localStorage.getItem('admin')).token
                : null;
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        fetchDashboardStats: builder.query({
            query: () => 'admin/dashboard',
        }),
    }),
});

export const { useFetchDashboardStatsQuery } = dashboardService;
export default dashboardService;
